import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AchAgreementModalComponent } from './ach-agreement-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxKjuaModule } from 'ngx-kjua';
import { BankAccountService } from '../../angular-wallet-base/services/bank-account.service';
import { BrowserModule } from '@angular/platform-browser';
import { TosContractsModule } from '../tos-contracts/tos-contracts.module';

const routes: Routes = [
  {
    path: '',
    component: AchAgreementModalComponent
  },
];

@NgModule({
  imports: [
    NgxKjuaModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    TranslateModule,
    ReactiveFormsModule,
    TosContractsModule,
  ],
  exports: [],
  declarations: [AchAgreementModalComponent],
  providers: [BankAccountService]
})
export class AchAgreementModalModule {
}
